import { render, staticRenderFns } from "./ShopVisits.vue?vue&type=template&id=331214d8&scoped=true&"
import script from "./ShopVisits.vue?vue&type=script&lang=js&"
export * from "./ShopVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331214d8",
  null
  
)

export default component.exports